const GROUP_BY = 1000
const DOLLARS_PAD_LENGTH = 3
const CENTS_PAD_LENGTH = 2

function formatDollars(dollarsValue) {
  if (dollarsValue < GROUP_BY) {
    return dollarsValue
  }
  const groups = []
  let left = dollarsValue
  while (left >= GROUP_BY) {
    const group = left % GROUP_BY
    groups.push(group.toString().padStart(DOLLARS_PAD_LENGTH, '0'))
    left = Math.floor(left / GROUP_BY)
  }
  return `${left},${groups.reverse().join(',')}`
}

function priceFormatter(price) {
  const cents = (price % 100).toString().padStart(CENTS_PAD_LENGTH, '0')
  return `$${formatDollars(Math.floor(price / 100))}.${cents}`
}

export default priceFormatter
